import { Dispatch, SetStateAction, useState } from 'react'

const useBody = ({getNotifications, setPage, page}:{ page: number; getNotifications: () => Promise<void>; setPage: Dispatch<SetStateAction<number>>}) => {
  const [anchorEl, setAnchorEl] = useState<Record<string, null | HTMLElement>>({
    profile: null,
    bell: null,
  })
  const handleClick = ({
    event,
    type,
  }: {
    event: React.MouseEvent<HTMLButtonElement> | null
    type: string
  }) => {
    setAnchorEl((prev) => ({
      ...prev,
      [type]: event ? event.currentTarget : event,
    }))
  }



  const refreshNotifications = () => {
    if(page==1){
      getNotifications()
    } else {
      setPage(1)
    }
  }

  return {
    anchorEl,
    handleClick,
    refreshNotifications,
  }
}

export { useBody }
